module.exports = __webpack_public_path__ + "static/media/arrow-menu.eb26030a.svg";